// API 配置
const API_BASE_URL = 'https://bjd-fan-jia-api.seedvault.cn';
// 前端基础URL（用于生成专属链接）
const BASE_URL = 'https://bjd-fan-jia.seedvault.cn';

export default {
  API_BASE_URL,
  BASE_URL
};
